  <div class="header">
    <app-header></app-header>
  </div>
  <div class="routerContent">
    <router-outlet></router-outlet>
  </div>
  <div class="footer">
    <app-footer></app-footer>
  </div>
